<template>
  <div class="block block-fx-pop" v-if="!called || filteredLinks.length > 0">
    <!-- v-show="!called || (called && links.length > 0)"> -->
    <div class="block-header block-header-default">
      <h3 class="block-title">{{ site.name }}</h3>
    </div>
    <div class="block-content">
      <p v-if="filteredLinks.length === 0">Geen links gevonden!</p>
      <table class="table table-sm table-hover table-vcenter" v-if="filteredLinks.length > 0">
        <thead>
          <tr>
            <th style="width: 30px" class="text-center">
              <div class="custom-control custom-checkbox d-inline-block">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="site.id + '-all'"
                  :name="site.id + '-all'"
                  :checked="allSelected"
                  v-on:change.prevent="selectAllLinks"
                />
                <label class="custom-control-label" :for="site.id + '-all'"></label>
              </div>
            </th>
            <th style="width: 130px" class="d-none d-sm-table-cell">Pagina</th>
            <th scope="col">Titel / Url</th>
            <th style="width: 130px" class="d-none d-xxl-table-cell">Startdatum</th>
            <th style="width: 130px" class="d-none d-md-table-cell">Vervaldatum</th>
            <th style="width: 130px" class="d-none d-xxl-table-cell">Status</th>
            <th style="width: 130px" class="d-table-cell">Prijs</th>
            <th style="width: 80px" class="text-center">Acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="link in filteredLinks" :key="link.id">
            <td class="text-center">
              <div class="custom-control custom-checkbox d-inline-block">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="site.id + '-link-' + link.id"
                  :name="site.id + '-link-' + link.id"
                  :checked="selectedLink(link)"
                  v-on:change.prevent="selectLink(link)"
                />
                <label class="custom-control-label" :for="site.id + '-link-' + link.id"></label>
              </div>
            </td>
            <td class="d-none d-sm-table-cell">{{ link.category.page.title }}</td>
            <td class="font-size-sm">
              <p class="font-w600 mb-1 text-truncate">
                {{ link.title | capitalize }}
              </p>
              <p class="text-muted mb-0 text-truncate">
                {{ link.url }}
              </p>
            </td>
            <td class="d-none d-xxl-table-cell">{{ link.started_at ? moment(link.started_at).format('DD-MM-YYYY') : 'n.v.t.' }}</td>
            <td class="d-none d-md-table-cell">
              <template v-if="link.expired_at && moment(link.expired_at).year() > 2200">
                Permanent
              </template>
              <template v-else>
                  {{ link.expired_at ? moment(link.expired_at).format('DD-MM-YYYY') : 'n.v.t.' }}
              </template>
            </td>
            <td class="d-none d-xxl-table-cell" :class="statusclass(link)">{{ link.status_name }}</td>
            <td class="d-table-cell">
              <template v-if="link.page_type === 'home'">
                <s v-if="site.home_price_discount">{{ site.home_price | currency }}</s>
                <span>{{ site.home_price_discount ? site.home_price_discount : site.home_price | currency }}</span>
              </template>
              <template v-else-if="link.page_type === 'daughter'">
                <s v-if="site.daughter_price_discount">{{ getDaughterPrice(link) | currency }}</s>
                <span>{{ getDaughterPrice(link, true) | currency }}</span>
              </template>
            </td>
            <td class="text-center">
              <a
                :href="$route('links.edit', site.id, link.id)"
                data-toggle="tooltip"
                data-placement="top"
                title="Link bewerken"
                data-original-title="Link bewerken"
              >
                <i class="fa fa-fw fa-pencil-alt"></i>
              </a>
              <button
                type="button"
                class="btn btn-sm btn-success ml-2"
                :disabled="notPurchasAble(link)"
                v-on:click="updateCart(link.page_type === 'daughter' ? 200 : 1, link)"
                data-toggle="tooltip"
                data-placement="top"
                :title="cartTooltip(link)"
                :data-original-title="cartTooltip(link)"
              >
                <i v-if="!link.cartItem" class="fas fa-cart-plus"></i>
                <i v-if="link.cartItem" class="fa fa-fw fa-check"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Fuse from 'fuse.js';
import moment from 'moment';
import EventBus from '../plugins/vue-event-bus';

export default {
  props: {
    site: {
      required: true,
    },
    selectedLinks: {
      required: true,
      default: () => [],
    },
    selectedFilters: {
      required: true,
      default: [],
    },
    cartItems: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data: () => {
    return {
      called: false,
      links: [],
      filteredLinks: [],
    };
  },
  computed: {
    allSelected: function() {
      var siteSelectedLinks = this.selectedLinks.filter((slink) => slink.site.id === this.site.id);
      return siteSelectedLinks.length === this.filteredLinks.length;
    },
  },
  created() {
    this.getData();
  },
  watch: {
    called: function(newValue, oldValue) {
      if (newValue === true) {
        this.$emit('loaded');
      }
    },
    selectedFilters: function() {
      this.applyFilters();
    },
    selectedLinks: function() {
      var siteSelectedLinks = this.selectedLinks.filter((slink) => slink.site.id === this.site.id);
      this.$emit('allSelected', siteSelectedLinks.length === this.filteredLinks.length);
    },
  },
  methods: {
    statusclass(link) {
      switch (link.status) {
        case 2:
          return 'text-danger';
          break;

        default:
          return '';
          break;
      }
    },
    isPermanent: function (link) {
      return link.expired_at && moment(link.expired_at).year() > 2200;
    },
    getDaughterPrice(link, discount = false) {
      if (this.isPermanent(link)) {
        return 'Permanent';
      }

      if (discount && this.site.daughter_price_discount) {
        return this.site.daughter_price_discount * 4;
      }
      
      return this.site.daughter_price * 4;
    },
    selectedLink(link) {
      var index = _.findIndex(this.selectedLinks, (slink) => {
        return slink.site.id === this.site.id && slink.id === link.id;
      });
      return index >= 0;
    },
    notPurchasAble: function(link) {
      if (this.isPermanent(link)) {
        return true;
      }

      link.cartItem = this.cartItems.find((item) => {
        return item.site ? item.site.id === this.site.id && item.link_id === link.id : null;
      });
      
      return link.cartItem;
    },
    cartTooltip: function (link) {
      if (this.isPermanent(link)) {
        return 'Deze link is al permanent';
      }

      if (link.page_type === 'daughter') {
        return 'Deze link permanent verlengen';
      }

      return 'Deze link verlengen met 1 jaar';
    },
    updateCart(period, link) {
      axios
        .post(route('cart.update'), {
          site_id: this.site.id,
          link_id: link.id,
          page_id: link.category.page.id,
          category_id: link.category.id,
          title: link.title,
          url: link.url,
          description: link.description,
          follow: link.follow,
          period: period,
          start_date: moment(link.expired_at).isAfter(moment()) ? moment(link.expired_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.errors = response.data.errors;
            if (response.data.success) {
              EventBus.publish('cart.refresh');

              this.$notify({
                group: 'main',
                type: 'success',
                title: 'De link is toegevoegd en staat in de winkelwagen klaar voor betaling',
              });
            }
          }
        });
    },
    getData() {
      this.links = this.site.links.filter((link) => !link.user_package_id);
      this.applyFilters();
      this.called = true;
    },
    applyFilters() {
      let links = this.links;
      let combinedFilters = [];
      this.selectedFilters
        .filter((selectedFilter) => selectedFilter.key !== 'site')
        .forEach((selectedFilter) => {
          var index = _.findIndex(combinedFilters, (cFilter) => {
            return cFilter.key === selectedFilter.key;
          });

          if (index >= 0) {
            combinedFilters[index].values.push(selectedFilter.value);
          } else {
            combinedFilters.push({
              key: selectedFilter.key,
              values: [selectedFilter.value],
            });
          }
        });

      combinedFilters
        .filter((selectedFilter) => selectedFilter.key !== 'search')
        .forEach((filter) => {
          links = links.filter((link) => {
            return link[filter.key] && filter.values.includes(link[filter.key]);
          });
        });

      this.filteredLinks = links;
      this.applySearch(combinedFilters);
    },
    applySearch(combinedFilters) {
      var fuse = new Fuse(this.filteredLinks, {
        threshold: 0.2,
        includeScore: false,
        useExtendedSearch: true,
        keys: ['title', 'url', 'category.page.title'],
      });
      combinedFilters
        .filter((selectedFilter) => selectedFilter.key === 'search')
        .forEach((filter) => {
          this.filteredLinks = fuse.search(filter.values.join('|')).map((result) => {
            return result.item;
          });
        });
    },
    selectLink(link, remove = true) {
      var index = _.findIndex(this.selectedLinks, (slink) => {
        return slink.site.id === this.site.id && slink.id === link.id;
      });

      if (index >= 0) {
        if (remove) {
          this.selectedLinks.splice(index, 1);
        }
      } else {
        link.site = this.site;
        this.selectedLinks.push(link);
      }

      this.$set(this.selectedLinks, this.selectedLinks);
    },
    toggleAllLinksFromParent(select) {
      this.filteredLinks.forEach((link) => {
        this.selectLink(link, !select);
      });
    },
    selectAllLinks() {
      if (this.allSelected) {
        this.filteredLinks.forEach((link) => {
          this.selectLink(link);
        });
      } else {
        this.filteredLinks.forEach((link) => {
          this.selectLink(link, false);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  table-layout: fixed;
}
</style>
